const initialState = {
  schedules:[],
  playlists:[],
  playlistOrder:'shuffle',
  tracks:[],
  selectTrack:null,
  skipIndex:1,
  skipType:null,
  classes:[],
  trackSrcs:[],
  trackArrBuff:null,
  downloadSize:0,
  currTrack:null,
  currTrackPos:0,
  currTrackLength:0,
  currPlaylist:null,
  currClassTime:0,
  currSectionTime:0,
  totalSectionTime:0,
  totalClassTime:0,
  startClass:false,
  classData:null,
  classType:null,
  error:null,
  ptp:null
}

export default function reducer(state = initialState, action){
  switch(action.type){
    case 'GET_INIT_PLAYER_PENDING':{
      state = {...state}
      break
    }
    case 'GET_INIT_PLAYER_REJECTED':{
      state = {...state}
      break
    }
    case 'GET_INIT_PLAYER_FULFILLED':{
      const {
        tracks,
        playlists,
        schedules,
        classes
      } = action.payload.data
      state = {
        ...state,
        tracks:tracks,
        playlists:playlists,
        schedules:schedules,
        classes:classes
      }
      break
    }
    case 'GET_TRACK_SIZE_PENDING':{
      state = {...state}
      break
    }
    case 'GET_TRACK_SIZE_REJECTED':{
      state = {...state}
      break
    }
    case 'GET_TRACK_SIZE_FULFILLED':{
      state = {
        ...state,
        downloadSize:parseInt(action.payload.data.filesize) + parseInt(state.downloadSize),
        trackSrcs:state.trackSrcs.concat(action.payload.data.track)
      }
      break
    }
    case 'DOWNLOAD_COMPLETE':{
      state = {
        ...state,
        trackSrcs:state.trackSrcs.filter(track => track.id !== action.payload)
      }
      break
    }
    case 'FETCH_TRACK_PENDING':{
      state = {...state,loading:true}
      break
    }
    case 'FETCH_TRACK_REJECTED':{
      state = {...state,error:action.payload}
      break
    }
    case 'FETCH_TRACK_FULFILLED':{
      const track = {
        ...state.track,
        isPlaying:true
      }

      state = {
        ...state,
        trackUrl:action.payload.data.file_small.filename.src,
        track: track
      }
      break
    }
    case 'CURR_TRACK':{
      state = {
        ...state,
        currTrack:action.payload
      }
      break
    }
    case 'START_CLASS':{
      state = {
        ...state,
        startClass:true,
        classData:action.payload.classData,
        classTypes:action.payload.classTypes
      }
      break
    }
    case 'CLASS_STARTED':{
      state = {
        ...state,
        startClass:false
      }
      break
    }
    case 'CURR_PLAYLIST':{
      state = {
        ...state,
        currPlaylist:action.payload && action.payload.playlist
      }
      break
    }
    case 'CURR_CLASS_TIME':{
      state = {
        ...state,
        currClassTime:action.payload
      }
      break
    }
    case 'CURR_SECTION_TIME':{
      state = {
        ...state,
        currSectionTime:action.payload
      }
      break
    }
    case 'TOTAL_SECTION_TIME':{
      state = {
        ...state,
        totalSectionTime:action.payload
      }
      break
    }
    case 'TOTAL_CLASS_TIME':{
      state = {
        ...state,
        totalClassTime:action.payload
      }
      break
    }
    case 'START_PTP':{
      state = {
        ...state,
        ptp:action.payload,
        currPlaylist:action.payload
      }
      break
    }
    case 'SET_TRACKS':{
      state = {
        ...state,
        tracks:action.payload
      }
      break
    }
    case 'SET_TRACK_ARR_BUFFER':{
      state = {
        ...state,
        trackArrBuff:action.payload
      }
      break
    }
    case 'SET_CURR_TRACK_POS':{
      state = {
        ...state,
        currTrackPos:action.payload
      }
      break
    }
    case 'SET_CURR_TRACK_LENGTH':{
      state = {
        ...state,
        currTrackLength:action.payload
      }
      break
    }
    case 'SET_PLAYLIST_ORDER':{
      state = {
        ...state,
        playlistOrder:action.payload
      }
      break
    }
    case 'SELECT_TRACK':{
      state = {
        ...state,
        selectTrack:action.payload
      }
      break
    }
    case 'SKIP_FORWARD':{
      state = {
        ...state,
        skipIndex:++state.skipIndex,
        skipType:'forward'
      }
      break
    }
    case 'SKIP_BACK':{
      state = {
        ...state,
        skipIndex:++state.skipIndex,
        skipType:'back'
      }
      break
    }
    /*case 'FETCH_TRACK_INFO':{
      const track = {
        ...state.track,
        id:action.meta.track.id,
        title:action.meta.track.title,
        artist:action.meta.track.artist,
        album:action.meta.track.album,
        energy:action.meta.track.energy,
        isPlaying:false
      }

      state = {
        ...state,
        track: track,
        trackType: action.meta.trackType
      }
      break
    }
    case 'PLAY_PAUSE_TRACK':{
      state = {
        ...state,
        track:{
          ...state.track,
          isPlaying:!state.track.isPlaying
        }
      }
      break
    }
    case 'APP_BODY_CLICK':{
      state = {...state,showQueueOverlay:false, error: null }
      break
    }
    case 'TOGGLE_QUEUE_OVERLAY':{
      state = {...state,showQueueOverlay:action.payload}
      break
    }
    case 'TOGGLE_QUEUE_LOOP':{
      state = {...state,loopQueue:action.payload}
      break
    }
    case 'FETCH_QUEUE':{
      if (action.payload) {
        const tracks = action.payload.map((track)=>{
          track.isPlaying = track.id === action.meta
          return track
        })
        state = {
          ...state,
          queue: tracks
        }
      } else {
        state = {
          ...state,
          queue: []
        }
      }
      break
    }
    case 'ADD_TRACK_TO_QUEUE':{
      if (state.queue.find(track => track.id === action.payload.id)) {
        state = {
          ...state,
          error: 'Track already in queue'
        }
      } else {
        action.payload.isPlaying = false
        state = {
          ...state,
          queue: state.queue.concat(action.payload),
          error: null
        }
        addToQueue(action.payload)
      }
      break
    }
    case 'DELETE_FROM_QUEUE':{
      state = {
        ...state,
        queue: getQueue()
      }
      break
    }
    case 'DELETE_ALL_FROM_QUEUE':{
      state = {
        ...state,
        queue: []
      }
      break
    }
    case 'ADD_ALL_TO_PLAYLIST':{
      console.log('ADD_ALL_TO_PLAYLIST', action.payload)
      break
    }*/
  }
  return state
}



// WEBPACK FOOTER //
// ./src/store/reducers/playerReducer.js